import React from 'react'
import { useStateValue } from '../../state'

const Tags = () => {
  let [currentState] = useStateValue()
  return (
    currentState.tags.length > 0 && (
      <div className="tag-container">
        <p>My Tags:</p>
        <div className="ml-5">
          {currentState.tags.map((tag, i) => (
            <a className="tag_button" key={i}>{`#${tag}`}</a>
          ))}
        </div>
      </div>
    )
  )
}

export default Tags
